import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { v4 as uuid } from "uuid";
import { useStackManager } from "../../hooks/useStackManager";
import { TLSnackbar } from "./TLSnackbar";

export const SnackbarCtx = createContext({
  updateItem: () => console.error("[SnackbarCtx.updateItem] missing context"),
  destroyItem: () => console.error("[SnackbarCtx.destroyItem] missing context"),
});

export const SnackbarProvider = ({ children }) => {
  const { stack, ctx, mapProps } = useStackManager();

  return (
    <SnackbarCtx.Provider value={ctx}>
      {children}
      <div style={{ position: "absolute" }}>
        {stack.map((item) => (
          <TLSnackbar {...mapProps(item)} />
        ))}
      </div>
    </SnackbarCtx.Provider>
  );
};

const obj = {};
export const useSnackbar = (
  snackbar = obj,
  { destroyOnUnmount = false } = obj,
) => {
  const id = useRef(uuid());
  const { updateItem, destroyItem } = useContext(SnackbarCtx);

  useEffect(() => {
    const withId = { ...snackbar, id: id.current };
    updateItem(withId);
  }, [snackbar, updateItem]);

  const destroyOnUnmountRef = useRef(destroyOnUnmount);
  destroyOnUnmountRef.current = destroyOnUnmount;
  useEffect(
    () => () => {
      if (destroyOnUnmountRef.current) destroyItem({ id: id.current });
    },
    [destroyItem],
  );

  return {
    show: useCallback(
      (item = {}) => updateItem({ id: id.current, open: true, ...item }),
      [updateItem],
    ),
  };
};
